import React, { useState, useRef, useEffect } from 'react';
import { CarrierSprt } from './carrier-sprite.styles';

const CarrierSprite = props => {
  const [isVisible, setIsVisible] = useState(false);
  const { alt = '', fallback = '', className = '' } = props;
  const sourceRef = useRef();
  const [error, setOnError] = useState(false);

  const imagePlaceholder =
    'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
  };

  let observer = null;
  const IntersectionObserver = typeof window === 'undefined' ? null : window.IntersectionObserver;

  useEffect(() => {
    if (IntersectionObserver) {
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          // if element is intersecting as per threshold set, then update state and remove observer
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.disconnect(entry.target);
          }
        });
      }, options);
    }

    if (observer) observer.observe(sourceRef.current);

    return () => {
      if (observer && observer.current) observer.current.disconnect();
    };
  }, []);

  if (error) return <img ref={sourceRef} {...props} src={fallback} alt={alt} />;

  return (
    <CarrierSprt
      ref={sourceRef}
      url={
        IntersectionObserver
          ? isVisible
            ? 'https://imgak.goibibo.com/flights-gi-assets/images/v2/app-img/spriteDomestic.png?v=4'
            : imagePlaceholder
          : ''
      }
      className={className}
      onError={() => {
        setOnError(true);
      }}
      data-testid={props['data-testid'] || ''}
    />
  );
};

export default CarrierSprite;
